// Components/ui
import { Box, Select, TextField, styled, IconButton } from '@mui/material';

export const StyledReminderItemContainer = styled(Box)(() => ({
  marginBottom: '6px',
  padding: '8px 16px',
  border: '1px solid lightgray',
  borderRadius: '3px',
})) as typeof Box;
export const StyledReminderItemViewContainer = styled(Box)(() => ({
  marginBottom: '6px',
  padding: '4px 0px',
})) as typeof Box;
export const StyledReminderInputsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  userSelect: 'none',
})) as typeof Box;
export const StyledReminderTextField = styled(TextField)(() => ({
  width: '13%',
})) as typeof TextField;
export const StyledReminderSelect = styled(Select)(() => ({
  width: '23%',
})) as unknown as typeof Select;
export const StyledReminderActionsContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 1,
  width: '100%',
  alignItems: 'center',
})) as typeof Box;
export const StyledReminderDeleteIconButton = styled(IconButton)(() => ({
  ml: 'auto',
  color: 'error',
})) as typeof IconButton;
